/* ============================================================
   devyne – PDP UX Enhancements v2.7
   (v2.7: Sticky-Landingpage-CTA-Button komplett entfernt. Die Logik
   griff zu pauschal - auf redaktionellen "Page"-Templates wie
   "Über uns" nahm sie einfach den ersten gefundenen Button-/
   Kategorie-Link auf der Seite, was zu kontextlosen/falschen
   Button-Beschriftungen führte. Ergibt so keinen Sinn und wurde
   ersatzlos gestrichen.)
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     TOAST
  ---------------------------------------------------------- */
  function createToast() {
    if (document.getElementById('devyne-toast')) return;
    var toast = document.createElement('div');
    toast.id = 'devyne-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span>In den Warenkorb gelegt</span>';
    document.body.appendChild(toast);
  }
  function showToast() {
    var toast = document.getElementById('devyne-toast');
    if (!toast) return;
    toast.classList.remove('devyne-toast--visible');
    void toast.offsetWidth;
    toast.classList.add('devyne-toast--visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function() { toast.classList.remove('devyne-toast--visible'); }, 3200);
  }
  function watchCart() {
    var lastCartUpdateAt = 0;

    document.addEventListener('cart:updated', function() {
      lastCartUpdateAt = Date.now();
      showToast();
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('buy-buttons [type="submit"]');
      if (!btn || btn.disabled) return;
      var clickedAt = Date.now();
      setTimeout(function() {
        if (lastCartUpdateAt >= clickedAt) return;
        if (!document.querySelector('.product-form .alert')) showToast();
      }, 1000);
    });
  }

  /* ----------------------------------------------------------
     ZURÜCK-NAVIGATION (Mobile)
     v2.8: Blendet sich erst NACH dem Hero-/ersten Bild der Seite ein,
     statt sofort ueber dem Bild zu schweben (störte z. B. auf
     "Über uns", wo die Leiste direkt über dem Team-Foto lag).
  ---------------------------------------------------------- */
  function initBackNav() {
    if (window.innerWidth > 767) return;
    if (window.history.length < 2) return;

    var body = document.body;
    var isPDP = body.classList.contains('template-product');
    var isColl = body.classList.contains('template-collection');
    var isPage = body.classList.contains('template-page');

    if (!isPDP && !isColl && !isPage) return;

    var bar = document.createElement('div');
    bar.id = 'devyne-back-nav';
    bar.innerHTML = '<button class="devyne-back-nav__btn" aria-label="Zur\u00fcck"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>Zur\u00fcck</button>';
    bar.querySelector('button').addEventListener('click', function() { history.back(); });

    /* devyne v2.6: als fixed-positioniertes, aus dem Dokumentfluss
       genommenes Element an body anhaengen - unabhaengig davon, ob die
       Seite einen transparenten Header/Hero-Bereich hat oder nicht. */
    document.body.appendChild(bar);

    /* devyne v2.8: erst sichtbar, wenn am ersten Medien-Element (Hero-
       Bild/-Video) der Seite vorbeigescrollt wurde. Ohne erkennbares
       Medienelement bleibt das alte Verhalten (sofort sichtbar). */
    var heroMedia = document.querySelector('main img, main video');

    if (!heroMedia) {
      bar.classList.add('devyne-back-nav--visible');
      return;
    }

    function updateBackNavVisibility() {
      var rect = heroMedia.getBoundingClientRect();
      var headerOffset = 64;
      if (rect.bottom <= headerOffset) {
        bar.classList.add('devyne-back-nav--visible');
      } else {
        bar.classList.remove('devyne-back-nav--visible');
      }
    }

    updateBackNavVisibility();
    window.addEventListener('scroll', updateBackNavVisibility, { passive: true });
  }

  /* INIT */
  function init() {
    createToast();
    watchCart();
    initBackNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
